import styled from 'styled-components';
import { Modal as CustomModal } from '@getinapp/appetizer';

export const Modal = styled(CustomModal)`
  background: white;

  svg {
      display: none !important;
    }
`;

export const WrapperButtons = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 2rem;
`;
